function formatLineItem() {
    const lineItems = document.querySelectorAll('.CartItem__Property');
    lineItems.forEach((property) => {
        const propertyFirst = property.textContent.split(':')[0].trim();
        const propertyLast = property.textContent.replace(propertyFirst + ':', '').trim();
        if (propertyLast.includes('Quadratmeterpreis')) {
            const width = propertyLast.split('|')[1].split(':')[1].trim();
            const length = propertyLast.split('|')[0].split(':')[1].trim();
            property.innerHTML = `<b>Größe:</b><br>Länge: ${length.replace('.',',')} cm<br>Fixe Breite: ${width.replace('.',',')} cm`;
        }
    })
}

window.addEventListener('cart::rerendered',formatLineItem);
window.addEventListener('load',formatLineItem);